import { Outlet } from "react-router-dom";
import { publicDir } from "../../config/config";
import CopyrightFooter from "../../components/common/CopyrightFooter";
import LoginIntro from "../../components/common/LoginIntro";

export default function PageAuth() {
  return <div className="PageAuth" data-comp="PageAuth">
    <div className="PA__row">
      <div className="PA__col PA__col--desc">
        <div className="PA__col--desc-inner">
          <LoginIntro />
        </div>
      </div>
      <div className="PA__col PA__col--main">
        {/* <div className="PA__main"> */}
        <Outlet />
        <div className="text-center mt-5 copyright__auth--mobile">
          <CopyrightFooter align="center" />
        </div>
        {/* </div> */}
      </div>
    </div>
  </div>
}
